import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  ViewEncapsulation,
} from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { BspkIcon } from '@bspk/ngx-ui';

const DEFAULT = {
  size: 'small',
  color: 'grey',
  showTooltip: true,
} as const;

export type SizeVariant =
  | 'large'
  | 'medium'
  | 'small'
  | 'x-large'
  | 'x-small'
  | 'xx-large'
  | 'xxx-large'
  | 'xxxx-large'
  | 'xxxxx-large';

@Component({
  selector: 'bspk-avatar',
  imports: [BspkIcon, NgOptimizedImage],
  templateUrl: './avatar.component.html',
  styleUrl: './avatar.component.scss',
  host: {
    'data-bspk': 'avatar',
    '[attr.data-color]': 'color()',
    '[attr.data-size]': 'size()',
    '[attr.aria-label]': 'name()',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class BspkAvatar {
  readonly name = input.required<string>();
  readonly size = input<SizeVariant>(DEFAULT.size);
  readonly color = input<string>(DEFAULT.color);
  readonly initials = input<string>();
  readonly showIcon = input(false, { transform: booleanAttribute });
  readonly image = input<string>();

  readonly initialsValue = computed(() => {
    const initials = this.initials();
    if (initials) {
      return initials;
    }

    if (this.name()) {
      return this.name()
        .split(' ')
        .map((word) => word.charAt(0))
        .slice(0, 2)
        .join('')
        .toUpperCase();
    }

    return '';
  });
}
